import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UltimasEntregasModel } from '../shared/models/ultimasEntregasModel';
import { Util, StatusEntrega, StatusRoteiroPedidos } from '../shared/Util';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { NgIf, NgClass, NgFor, DatePipe } from '@angular/common';
declare let jsPDF;

@Component({
    selector: 'card-ultimas-entregas',
    templateUrl: './card-ultimas-entregas.component.html',
    styleUrls: ['./card-ultimas-entregas.component.css'],
    standalone: true,
    imports: [NgIf, NgClass, NgFor, DatePipe]
})
export class CardUltimasEntregasComponent{

  constructor(private boxInfoRouter: BoxInfoRouterService) { }

  @Input() ultimasEntregas: Array<UltimasEntregasModel> = [];
  @Output() abrirModalMapa = new EventEmitter<number[]>();  
  @Input() isModal = false;

  abriRoteiro(numeroRoteiro: number, numeroPedido: number){

    if(this.isModal){
      document.getElementById('btnCloseUltimaEnrtega').click()
    }
    this.abrirModalMapa.emit([numeroRoteiro, numeroPedido]);
  }

  downloadPDFRecibo(item) {
  let numeroNota = 26;
  let imgData = 'data:image/jpeg;base64,' + item.Arquivo;

  const doc = new jsPDF('l', 'mm', [297, 260]), // paisagem
    titulos = 16,
    informacaoes = 26,
    data = 26;

  let alturaImagem = 28;

  doc.setDrawColor(0);
  doc.setFillColor(255, 255, 255);

  // Cabeçalho
  doc.text(8, titulos, 'DATA');
  doc.setFontType('bold');
  doc.setFontSize(16);
  doc.text(
    8,
    data,
    new Date(item.DataEntrega).toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  );

  doc.setFontType('normal');
  doc.text(69, titulos, 'IDENTIFICAÇÃO');
  doc.setFontType('bold');
  doc.text(109, informacaoes, item.NomeRecebedor.substring(0, 25));
  doc.text(200, informacaoes, item.DocumentoRecebedor);
  doc.setFontType('normal');
  doc.text(180, informacaoes, 'DOC.:');
  doc.text(69, informacaoes, 'RECEBEDOR:');
  doc.text(252, titulos, 'NF-E');

  // Nota fiscal
  doc.setFontType('normal');
  doc.text(252, numeroNota, `Nº `);
  doc.setFontType('bold');
  doc.text(260, numeroNota, `${item.Nf}`);
  numeroNota += 6;
  alturaImagem += 4;

  doc.setFontType('normal');

  // corrige orientação antes de inserir
  this.fixOrientation(imgData, (fixedImg) => {
    try {
      doc.addImage(fixedImg, 'JPEG', 0, alturaImagem + 10); 
    } catch (error) {
      let fallbackImg = 'data:image/png;base64,' + item.Arquivo;
      this.fixOrientation(fallbackImg, (fixedPng) => {
        doc.addImage(fixedPng, 'PNG', 0, alturaImagem + 10);
      });
    }

    // Nome do arquivo
    let nomeArquivo = '';

   nomeArquivo = `NF_${item.Nf}`;
    doc.save(`${nomeArquivo}.pdf`);
  });
}

  private fixOrientation(base64: string, callback: (fixed: string) => void) {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0);
        callback(canvas.toDataURL('image/jpeg'));
      };
      img.src = base64;
    }

  async getComprovante(item){
    if(item.IdPedidoConfirmacaoEntrega && item.NomeRecebedor == undefined){
      let resultado = await this.boxInfoRouter.getComprovante(item.IdPedidoConfirmacaoEntrega)
      item.NomeRecebedor = resultado.NomeRecebedor;
      item.DocumentoRecebedor = resultado.DocumentoRecebedor;
      console.log("item e resultado");
      console.log(item);
      console.log(resultado)

      if(resultado.Arquivo){
          item.Arquivo = Util.decompress(resultado.Arquivo);
          this.downloadPDFRecibo(item)
      }
    }
  }
}
